import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ExposedPromise, ExposedPromiseStatus } from '../../utils/exposed-promise';
import { Serializer, TransportStatus, BeaconMessageType } from '../..';
import { BeaconEventHandler, BeaconEvent } from '../../events';
import { BeaconClient } from '../beacon-client/BeaconClient';
import { AccountManager } from '../../managers/AccountManager';
import { generateGUID } from '../../utils/generate-uuid';
import { BEACON_VERSION } from '../../constants';
import { getSenderId } from '../../utils/get-sender-id';
import { Logger } from '../../utils/Logger';
var logger = new Logger('Client');
/**
 * @internalapi
 *
 * This abstract class handles the a big part of the logic that is shared between the dapp and wallet client.
 * For example, it selects and manages the transport and accounts.
 */

export var Client = /*#__PURE__*/function (_BeaconClient) {
  _inherits(Client, _BeaconClient);

  var _super2 = _createSuper(Client);

  function Client(config) {
    var _this;

    _classCallCheck(this, Client);

    var _a, _b;

    _this = _super2.call(this, config);
    /**
     * How many requests can be sent after another
     */

    _this.rateLimit = 2;
    /**
     * The time window in seconds in which the "rateLimit" is checked
     */

    _this.rateLimitWindowInSeconds = 5;
    /**
     * Stores the times when requests have been made to determine if the rate limit has been reached
     */

    _this.requestCounter = [];
    _this._transport = new ExposedPromise();
    _this.events = new BeaconEventHandler(config.eventHandlers, (_a = config.disableDefaultEvents) !== null && _a !== void 0 ? _a : false);
    _this.accountManager = new AccountManager(config.storage);
    _this.matrixNodes = (_b = config.matrixNodes) !== null && _b !== void 0 ? _b : [];

    _this.handleResponse = function (message, connectionInfo) {
      throw new Error("not overwritten".concat(JSON.stringify(message), " - ").concat(JSON.stringify(connectionInfo)));
    };

    return _this;
  }

  _createClass(Client, [{
    key: "transport",
    get: function get() {
      return this._transport.promise;
    }
    /**
     * Returns the connection status of the Client
     */

  }, {
    key: "connectionStatus",
    get: function get() {
      var _a, _b;

      return (_b = (_a = this._transport.promiseResult) === null || _a === void 0 ? void 0 : _a.connectionStatus) !== null && _b !== void 0 ? _b : TransportStatus.NOT_CONNECTED;
    }
    /**
     * Returns whether or not the transaport is ready
     */

  }, {
    key: "ready",
    get: function get() {
      return this.transport.then(function () {
        return undefined;
      });
    }
    /**
     * Return all locally known accounts
     */

  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.accountManager.getAccounts());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Return the account by ID
     * @param accountIdentifier The ID of an account
     */

  }, {
    key: "getAccount",
    value: function getAccount(accountIdentifier) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.accountManager.getAccount(accountIdentifier));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Remove the account by ID
     * @param accountIdentifier The ID of an account
     */

  }, {
    key: "removeAccount",
    value: function removeAccount(accountIdentifier) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.accountManager.removeAccount(accountIdentifier));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Remove all locally stored accounts
     */

  }, {
    key: "removeAllAccounts",
    value: function removeAllAccounts() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.accountManager.removeAllAccounts());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Add a new request (current timestamp) to the pending requests, remove old ones and check if we are above the limit
     */

  }, {
    key: "addRequestAndCheckIfRateLimited",
    value: function addRequestAndCheckIfRateLimited() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var now;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                now = new Date().getTime();
                this.requestCounter = this.requestCounter.filter(function (date) {
                  return date + _this2.rateLimitWindowInSeconds * 1000 > now;
                });
                this.requestCounter.push(now);
                return _context5.abrupt("return", this.requestCounter.length > this.rateLimit);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * This method initializes the client. It will check if the connection should be established to a
     * browser extension or if the P2P transport should be used.
     *
     * @param transport A transport that can be provided by the user
     */

  }, {
    key: "init",
    value: function init(transport) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this._transport.status === ExposedPromiseStatus.RESOLVED)) {
                  _context6.next = 4;
                  break;
                }

                _context6.next = 3;
                return this.transport;

              case 3:
                return _context6.abrupt("return", _context6.sent.type);

              case 4:
                _context6.next = 6;
                return this.setTransport(transport);

              case 6:
                return _context6.abrupt("return", transport.type);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Returns the metadata of this DApp
     */

  }, {
    key: "getOwnAppMetadata",
    value: function getOwnAppMetadata() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = getSenderId;
                _context7.next = 3;
                return this.beaconId;

              case 3:
                _context7.t1 = _context7.sent;
                _context7.next = 6;
                return (0, _context7.t0)(_context7.t1);

              case 6:
                _context7.t2 = _context7.sent;
                _context7.t3 = this.name;
                _context7.t4 = this.iconUrl;
                return _context7.abrupt("return", {
                  senderId: _context7.t2,
                  name: _context7.t3,
                  icon: _context7.t4
                });

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Return all known peers
     */

  }, {
    key: "getPeers",
    value: function getPeers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.transport;

              case 2:
                return _context8.abrupt("return", _context8.sent.getPeers());

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Add a new peer to the known peers
     * @param peer The new peer to add
     */

  }, {
    key: "addPeer",
    value: function addPeer(peer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.transport;

              case 2:
                return _context9.abrupt("return", _context9.sent.addPeer(peer));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this3 = this;

      var _super = Object.create(null, {
        destroy: {
          get: function get() {
            return _get(_getPrototypeOf(Client.prototype), "destroy", _this3);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this._transport.status === ExposedPromiseStatus.RESOLVED)) {
                  _context10.next = 5;
                  break;
                }

                _context10.next = 3;
                return this.transport;

              case 3:
                _context10.next = 5;
                return _context10.sent.disconnect();

              case 5:
                _context10.next = 7;
                return _super.destroy.call(this);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * A "setter" for when the transport needs to be changed.
     */

  }, {
    key: "setTransport",
    value: function setTransport(transport) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (transport) {
                  if (this._transport.isSettled()) {
                    // If the promise has already been resolved we need to create a new one.
                    this._transport = ExposedPromise.resolve(transport);
                  } else {
                    this._transport.resolve(transport);
                  }
                } else {
                  if (this._transport.isSettled()) {
                    // If the promise has already been resolved we need to create a new one.
                    this._transport = new ExposedPromise();
                  }
                }

                _context11.next = 3;
                return this.events.emit(BeaconEvent.ACTIVE_TRANSPORT_SET, transport);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "addListener",
    value: function addListener(transport) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                transport.addListener(function (message, connectionInfo) {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                    var deserializedMessage;
                    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            if (!(typeof message === 'string')) {
                              _context12.next = 5;
                              break;
                            }

                            _context12.next = 3;
                            return new Serializer().deserialize(message);

                          case 3:
                            deserializedMessage = _context12.sent;
                            this.handleResponse(deserializedMessage, connectionInfo);

                          case 5:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  }));
                }).catch(function (error) {
                  return logger.error('addListener', error);
                });

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));
    }
  }, {
    key: "sendDisconnectToPeer",
    value: function sendDisconnectToPeer(peer, transport) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var request, payload, selectedTransport;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return generateGUID();

              case 2:
                _context14.t0 = _context14.sent;
                _context14.t1 = BEACON_VERSION;
                _context14.t2 = getSenderId;
                _context14.next = 7;
                return this.beaconId;

              case 7:
                _context14.t3 = _context14.sent;
                _context14.next = 10;
                return (0, _context14.t2)(_context14.t3);

              case 10:
                _context14.t4 = _context14.sent;
                _context14.t5 = BeaconMessageType.Disconnect;
                request = {
                  id: _context14.t0,
                  version: _context14.t1,
                  senderId: _context14.t4,
                  type: _context14.t5
                };
                _context14.next = 15;
                return new Serializer().serialize(request);

              case 15:
                payload = _context14.sent;

                if (!(transport !== null && transport !== void 0)) {
                  _context14.next = 20;
                  break;
                }

                _context14.t6 = transport;
                _context14.next = 23;
                break;

              case 20:
                _context14.next = 22;
                return this.transport;

              case 22:
                _context14.t6 = _context14.sent;

              case 23:
                selectedTransport = _context14.t6;
                _context14.next = 26;
                return selectedTransport.send(payload, peer);

              case 26:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }]);

  return Client;
}(BeaconClient);